import React, { useEffect, useRef, useState } from 'react';
import {
  Button,
  // Card,
  Form,
  Input,
  InputNumber,
  Modal,
  // Row,
  Select,
  Space,
  Tabs,
  // Table,
  Typography,
} from 'antd';
import IntlMessages from '../../../components/IntlMessage';
// import SearchOrderForm from './SearchOrderForm';
import { useIntl } from 'react-intl';
import userApi from '../../../api/user';
import { useDispatch, useSelector } from 'react-redux';
import Departure from './Departure';
import Return from './Return';
// import dayjs from 'dayjs';
import orderApi from '../../../api/order';
import {
  clearEditOrderValues,
  updateSearchEditOrderValues,
} from '../../../redux/actions/EditOrderAction';
// import Currency from '../../../components/Currency';
import _ from 'lodash';
import useTime from '../../../hooks/useTime';
import useValidate from '../../../hooks/useValidate';
import { OrderStatus } from '../../../utils/constant';

const { Text } = Typography;
const { TextArea } = Input;

const layout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 16 },
};

const EditOrderForm = (props) => {
  const dispatch = useDispatch();
  const departureEditOrder = useSelector((state) => state.editOrder.departure);
  const returnEditOrder = useSelector((state) => state.editOrder.return);
  const searchOrderValues = useSelector(
    (state) => state.editOrder.searchValues
  );
  const userAuth = useSelector((state) => state.auth.authUser);
  const { isEmail } = useValidate();
  // states
  const { onClose, currentData, open, onReload } = props;
  const [loading, setLoading] = useState(false);
  const isMount = useRef(false);
  const [departureSearchData, setDepartureSearchData] = useState([]);
  const [returnSearchData, setReturnSearchData] = useState([]);
  const intl = useIntl();
  const [userOptions, setUserOptions] = useState([]);
  const [userSelected, setUserSelected] = useState(currentData?.user?.id);
  const [groupCode, setGroupCode] = useState(currentData?.group_code);
  // const [totalMoney, setTotalMoney] = useState(currentData?.total);
  // const [showSearchResult, setShowSearchResult] = useState(true);
  const [form] = Form.useForm();
  const { formatAsISOString, convertToAnyTimezone } = useTime();
  const [orderNotes, setOrderNotes] = useState(currentData?.notes);
  const [orderInternalNotes, setOrderInternalNotes] = useState(
    currentData?.internal_notes
  );
  const [contacts, setContacts] = useState([]);
  const [contactSelected, setContactSelected] = useState({
    fullname: '',
    mobile: '',
    email: '',
  });
  const [isSelectOtherContact, setIsSelectOtherContact] = useState(false);
  const [pax, setPax] = useState(currentData?.qty);
  const [guideNumber, setGuideNumber] = useState(currentData?.guide_number);

  // side-effects
  useEffect(() => {
    isMount.current = true;
    if (isMount) {
      Promise.all([
        userApi.getAllUsers({
          page: 1,
          limit: 9999,
          keyword: '',
          order_by: 'id',
          order_dir: 'DESC',
        }),
      ])
        .then((res) => {
          const userData = res[0]?.data;
          setUserOptions(
            userData?.map((user) => ({
              label: `${user?.fullname}`,
              value: user?.id,
            }))
          );
        })
        .catch((error) => {
          console.error(error);
        });
    }

    return () => {
      isMount.current = false;
    };
  }, []);

  useEffect(() => {
    if (currentData) {
      const from = currentData?.hop?.start_stop?.id;
      const to = currentData?.hop?.end_stop?.id;
      const date = currentData?.roundtrip
        ? [
            convertToAnyTimezone(currentData?.date),
            convertToAnyTimezone(currentData?.return_date),
          ]
        : convertToAnyTimezone(currentData?.date);
      const pax = currentData?.qty;

      if (!currentData?.roundtrip) {
        const payload = {
          page: 1,
          limit: 9999,
          filter_name: ['from', 'to', 'date'],
          filter_value: [from, to, JSON.stringify(formatAsISOString(date))],
        };
        orderApi
          .searchOrder(payload)
          .then((res) => {
            // console.log('departure search data: ', res);
            setDepartureSearchData(res.data);
            setReturnSearchData([]);
            dispatch(
              updateSearchEditOrderValues({
                date: formatAsISOString(date),
                roundtrip: false,
                return_date: '',
              })
            );
          })
          .catch((error) => {
            console.error(error);
          });
      } else {
        const departurePayload = {
          page: 1,
          limit: 9999,
          filter_name: ['from', 'to', 'date'],
          filter_value: [from, to, JSON.stringify(formatAsISOString(date[0]))],
        };
        const returnPayload = {
          page: 1,
          limit: 9999,
          filter_name: ['from', 'to', 'date'],
          filter_value: [to, from, JSON.stringify(formatAsISOString(date[1]))],
        };
        Promise.all([
          orderApi.searchOrder(departurePayload),
          orderApi.searchOrder(returnPayload),
        ])
          .then((res) => {
            // console.log('two way search data: ', res);
            setDepartureSearchData(res[0].data);
            setReturnSearchData(res[1].data);
            dispatch(
              updateSearchEditOrderValues({
                date: formatAsISOString(date[0]),
                roundtrip: true,
                return_date: formatAsISOString(date[1]),
              })
            );
          })
          .catch((error) => {
            console.error(error);
          });
      }
    }
  }, [currentData]);

  useEffect(() => {
    if (currentData) {
      setContacts(
        JSON.parse(currentData?.customer?.contact_info)?.map((info, index) => ({
          label: `${info?.fullname} (${info?.email} - ${info?.mobile})`,
          value: index,
        }))
      );
      setContactSelected({
        fullname: JSON.parse(currentData?.contact_info)?.fullname,
        email: JSON.parse(currentData?.contact_info)?.email,
        mobile: JSON.parse(currentData?.contact_info)?.mobile,
      });
    }
  }, [currentData]);

  // useEffect(() => {
  //   const departureCabinTotal = departureEditOrder?.cabins.reduce(
  //     (prev, current) =>
  //       prev + Number(current.quantity) * Number(current.price),
  //     0
  //   );
  //   const departureAddonTotal = departureEditOrder?.addons.reduce(
  //     (prev, current) =>
  //       prev + Number(current.quantity) * Number(current.price),
  //     0
  //   );
  //   const returnCabinTotal = returnEditOrder?.cabins.reduce(
  //     (prev, current) =>
  //       prev + Number(current.quantity) * Number(current.price),
  //     0
  //   );
  //   const returnAddonTotal = returnEditOrder?.addons.reduce(
  //     (prev, current) =>
  //       prev + Number(current.quantity) * Number(current.price),
  //     0
  //   );
  //   setTotalMoney(
  //     departureCabinTotal +
  //       departureAddonTotal +
  //       returnCabinTotal +
  //       returnAddonTotal
  //   );
  // }, [departureEditOrder, returnEditOrder]);

  const handleCancel = () => {
    refresh();
    onClose();
  };

  const handleSubmit = () => {
    // console.log('departureEditOrder: ', departureEditOrder);
    // console.log('returnEditOrder: ', returnEditOrder);
    // console.log('searchOrderValues: ', searchOrderValues);
    // console.log('customer: ', currentData?.customer);
    // console.log('contact: ', contactSelected);
    // console.log('Code: ', groupCode);
    // console.log('user: ', userSelected);
    // console.log('order notes: ', orderNotes);
    // console.log('order internal notes: ', orderInternalNotes);
    // console.log('guide number: ', guideNumber);
    // console.log('pax: ', pax);
    setLoading(true);
    const { date, roundtrip, return_date } = searchOrderValues;
    let payload = {};
    if (searchOrderValues.roundtrip) {
      if (
        !currentData?.customer ||
        departureEditOrder.cabins.length < 1 ||
        returnEditOrder.cabins.length < 1 ||
        !userSelected ||
        !pax
      ) {
        Modal.error({
          title:
            'Missing customer, pax, seller, departure or return',
          okText: intl.formatMessage({ id: 'global.close' }),
        });
        setLoading(false);
      } else if (contactSelected.email && !isEmail(contactSelected.email)) {
        Modal.error({
          title: intl.formatMessage({ id: 'validate.is_not_email' }),
          okText: intl.formatMessage({ id: 'global.close' }),
        });
        setLoading(false);
      }
      // else if (
      //   contactSelected.mobile &&
      //   !isPhoneNumber(contactSelected.mobile)
      // ) {
      //   Modal.error({
      //     title: intl.formatMessage({ id: 'validate.is_not_phone_number' }),
      //     okText: intl.formatMessage({ id: 'global.close' }),
      //   });
      //   setLoading(false);
      // }
      else {
        payload = {
          group_code: groupCode,
          customer_id: currentData?.customer?.id,
          contact_info: JSON.stringify(contactSelected),
          user_id: userSelected,
          date,
          roundtrip,
          return_date,
          pax,
          hop_id: departureEditOrder.cabins[0]?.hop_id,
          return_hop_id: returnEditOrder.cabins[0]?.hop_id,
          notes: orderNotes,
          internal_notes: orderInternalNotes,
          guide_number: guideNumber,
          routes: [
            {
              hop_id: departureEditOrder.cabins[0]?.hop_id,
              date,
              cabins: _.map(departureEditOrder.cabins, (cabin) =>
                _.pick(cabin, ['cabin_id', 'quantity', 'price'])
              ).map((cabin) => ({
                id: cabin.cabin_id,
                qty: cabin.quantity,
                price: cabin.price,
              })),
              addons: _.map(departureEditOrder.addons, (addon) =>
                _.pick(addon, ['addon_id', 'quantity', 'price', 'notes'])
              ).map((addon) => ({
                id: addon.addon_id,
                qty: addon.quantity,
                price: addon.price,
                notes: addon.notes,
              })),
            },
            {
              hop_id: returnEditOrder.cabins[0]?.hop_id,
              date: return_date,
              cabins: _.map(returnEditOrder.cabins, (cabin) =>
                _.pick(cabin, ['cabin_id', 'quantity', 'price'])
              ).map((cabin) => ({
                id: cabin.cabin_id,
                qty: cabin.quantity,
                price: cabin.price,
              })),
              addons: _.map(returnEditOrder.addons, (addon) =>
                _.pick(addon, ['addon_id', 'quantity', 'price', 'notes'])
              ).map((addon) => ({
                id: addon.addon_id,
                qty: addon.quantity,
                price: addon.price,
                notes: addon.notes,
              })),
            },
          ],
        };
        // console.log('payload: ', payload);
        orderApi
          .updateOrder(currentData?.id, payload)
          .then(() => {
            refresh();
            setLoading(false);
            handleCancel();
            onReload();
          })
          .catch((error) => {
            console.error(error);
            Modal.error({
              title: error.data.message,
              okText: intl.formatMessage({ id: 'global.close' }),
            });
            setLoading(false);
          });
      }
    } else {
      if (
        !currentData?.customer ||
        departureEditOrder.cabins.length < 1 ||
        !userSelected ||
        !pax
      ) {
        Modal.error({
          title: 'Missing customer, pax, seller or departure',
          okText: intl.formatMessage({ id: 'global.close' }),
        });
        setLoading(false);
      } else if (contactSelected.email && !isEmail(contactSelected.email)) {
        Modal.error({
          title: intl.formatMessage({ id: 'validate.is_not_email' }),
          okText: intl.formatMessage({ id: 'global.close' }),
        });
        setLoading(false);
      } 
      // else if (
      //   contactSelected.mobile &&
      //   !isPhoneNumber(contactSelected.mobile)
      // ) {
      //   Modal.error({
      //     title: intl.formatMessage({ id: 'validate.is_not_phone_number' }),
      //     okText: intl.formatMessage({ id: 'global.close' }),
      //   });
      //   setLoading(false);
      // } 
      else {
        payload = {
          group_code: groupCode,
          customer_id: currentData?.customer?.id,
          contact_info: JSON.stringify(contactSelected),
          user_id: userSelected,
          date,
          roundtrip,
          return_date,
          pax,
          hop_id: departureEditOrder.cabins[0]?.hop_id,
          return_hop_id: null,
          notes: orderNotes,
          internal_notes: orderInternalNotes,
          guide_number: guideNumber,
          routes: [
            {
              hop_id: departureEditOrder.cabins[0]?.hop_id,
              date,
              cabins: _.map(departureEditOrder.cabins, (cabin) =>
                _.pick(cabin, ['cabin_id', 'quantity', 'price'])
              ).map((cabin) => ({
                id: cabin.cabin_id,
                qty: cabin.quantity,
                price: cabin.price,
              })),
              addons: _.map(departureEditOrder.addons, (addon) =>
                _.pick(addon, ['addon_id', 'quantity', 'price', 'notes'])
              ).map((addon) => ({
                id: addon.addon_id,
                qty: addon.quantity,
                price: addon.price,
                notes: addon.notes,
              })),
            },
          ],
        };
        // console.log('payload: ', payload);
        orderApi
          .updateOrder(currentData?.id, payload)
          .then(() => {
            refresh();
            setLoading(false);
            handleCancel();
            onReload();
          })
          .catch((error) => {
            console.error(error);
            Modal.error({
              title: error.data.message,
              okText: intl.formatMessage({ id: 'global.close' }),
            });
            setLoading(false);
          });
      }
    }
  };

  const refresh = () => {
    // setShowSearchResult(false);
    // setTotalMoney(0);
    setUserSelected(userAuth?.id);
    setGroupCode('');
    form.resetFields();
    dispatch(clearEditOrderValues());
  };

  // const handleSearchOrder = (values, isOneWay) => {
  //   refresh();
  //   const { from, to, pax, date } = values;
  //   if (isOneWay) {
  //     const payload = {
  //       page: 1,
  //       limit: 9999,
  //       filter_name: ['from', 'to', 'date', 'pax'],
  //       filter_value: [from, to, date.toISOString(), pax],
  //     };
  //     orderApi
  //       .searchOrder(payload)
  //       .then((res) => {
  //         console.log('departure search data: ', res);
  //         setDepartureSearchData(res.data);
  //         setReturnSearchData([]);
  //         setShowSearchResult(true);
  //         dispatch(
  //           updateSearchEditOrderValues({
  //             date: date.toISOString(),
  //             roundtrip: false,
  //             return_date: '',
  //             pax,
  //           })
  //         );
  //       })
  //       .catch((error) => {
  //         console.log(error);
  //       });
  //   } else {
  //     const departurePayload = {
  //       page: 1,
  //       limit: 9999,
  //       filter_name: ['from', 'to', 'date', 'pax'],
  //       filter_value: [from, to, date[0].toISOString(), pax],
  //     };
  //     const returnPayload = {
  //       page: 1,
  //       limit: 9999,
  //       filter_name: ['from', 'to', 'date', 'pax'],
  //       filter_value: [to, from, date[1].toISOString(), pax],
  //     };
  //     Promise.all([
  //       orderApi.searchOrder(departurePayload),
  //       orderApi.searchOrder(returnPayload),
  //     ])
  //       .then((res) => {
  //         console.log('two way search data: ', res);
  //         setDepartureSearchData(res[0].data);
  //         setReturnSearchData(res[1].data);
  //         setShowSearchResult(true);
  //         dispatch(
  //           updateSearchEditOrderValues({
  //             date: date[0].toISOString(),
  //             roundtrip: true,
  //             return_date: date[1].toISOString(),
  //             pax,
  //           })
  //         );
  //       })
  //       .catch((error) => {
  //         console.log(error);
  //       });
  //   }
  // };

  const handleSearchUser = (value) => {
    // console.log('value search user', value);
  };

  const handleSelectUser = (value) => {
    // console.log('value selected user', value);
    setUserSelected(value);
  };

  const handleInputGroupCode = (e) => {
    setGroupCode(e.target.value);
  };

  const handleChangePax = (value) => {
    // console.log(value);
    setPax(value);
  };

  const handleChangeGuideNumber = (value) => {
    setGuideNumber(value);
  };

  const handleInputOrderNotes = (e) => {
    setOrderNotes(e.target.value);
  };

  const handleInputOrderInternalNotes = (e) => {
    setOrderInternalNotes(e.target.value);
  };

  const handleInputContactName = (e) => {
    setContactSelected({ ...contactSelected, fullname: e.target.value });
  };

  const handleInputContactEmail = (e) => {
    setContactSelected({ ...contactSelected, email: e.target.value });
  };

  const handleInputContactMobile = (e) => {
    setContactSelected({ ...contactSelected, mobile: e.target.value });
  };

  const handleSearchContact = (value) => {
    // console.log('value search - contact:', value);
  };

  const handleSelectContact = (value) => {
    // console.log('value selected - contact:', value);
    setContactSelected({
      fullname: JSON.parse(currentData?.customer?.contact_info)[value].fullname,
      email: JSON.parse(currentData?.customer?.contact_info)[value].email,
      mobile: JSON.parse(currentData?.customer?.contact_info)[value].mobile,
    });
    setIsSelectOtherContact(false);
  };

  // const detailColumns = [
  //   {
  //     title: <IntlMessages id="global.no" />,
  //     width: '5%',
  //     render: (_, record, index) => {
  //       return index + 1;
  //     },
  //   },
  //   {
  //     title: <IntlMessages id="global.name" />,
  //     width: '50%',
  //     key: 'title',
  //     dataIndex: 'title',
  //     render: (_, record) => {
  //       return <Text>{record?.title}</Text>;
  //     },
  //   },
  //   {
  //     title: <IntlMessages id="global.price" />,
  //     width: '15%',
  //     key: 'price',
  //     dataIndex: 'price',
  //     render: (_, record) => {
  //       return <Currency value={record?.price} />;
  //     },
  //   },
  //   {
  //     title: <IntlMessages id="global.qty" />,
  //     width: '15%',
  //     key: 'quantity',
  //     dataIndex: 'quantity',
  //     render: (_, record) => {
  //       return <Text>{record?.quantity}</Text>;
  //     },
  //   },
  //   {
  //     title: <IntlMessages id="global.total" />,
  //     width: '15%',
  //     key: 'total',
  //     render: (_, record) => {
  //       return (
  //         <Currency value={Number(record?.price) * Number(record?.quantity)} />
  //       );
  //     },
  //   },
  // ];

  const tabItems = [
    {
      key: '1',
      label: <IntlMessages id="global.routes" />,
      children: (
        <React.Fragment>
          {departureSearchData.length > 0 && (
            <Departure
              searchData={departureSearchData}
              customer={currentData?.customer}
            />
          )}
          {returnSearchData.length > 0 && (
            <Return
              searchData={returnSearchData}
              customer={currentData?.customer}
            />
          )}
        </React.Fragment>
      ),
    },
    {
      key: '2',
      label: <IntlMessages id="global.order_information" />,
      children: (
        <React.Fragment>
          <Form
            {...layout}
            labelAlign="left"
            initialValues={{
              group_code: currentData?.group_code,
              user: currentData?.user?.id,
              notes: currentData?.notes,
              internal_notes: currentData?.internal_notes,
              pax: currentData?.qty,
              guide_number: currentData?.guide_number,
            }}
            form={form}
          >
            <Form.Item label={<IntlMessages id="global.customers" />}>
              <Text>{`${currentData?.customer?.fullname}${
                currentData?.customer?.company_shortname
                  ? ` - ${currentData?.customer?.company_shortname}`
                  : ''
              }${
                currentData?.customer?.mobile
                  ? ` - ${currentData?.customer?.mobile}`
                  : ''
              }${
                currentData?.customer?.cgroup
                  ? ` - ${currentData?.customer?.cgroup?.title}`
                  : ''
              }${
                currentData?.customer?.cgroup?.discount
                  ? ` - Discount: ${currentData?.customer?.cgroup?.discount}%`
                  : ''
              }`}</Text>
            </Form.Item>
            <Form.Item
              label={<IntlMessages id="global.contact" />}
              name="contact_info"
              rules={[
                {
                  required: false,
                },
              ]}
            >
              <Space direction="vertical" size={4} style={{ width: '100%' }}>
                <Space.Compact size={4} style={{ width: '100%' }}>
                  <Input
                    placeholder={intl.formatMessage({
                      id: 'global.input_contact_name',
                    })}
                    value={
                      contactSelected?.fullname
                        ? contactSelected?.fullname
                        : null
                    }
                    onChange={handleInputContactName}
                  />
                  <Input
                    placeholder={intl.formatMessage({
                      id: 'global.input_contact_email',
                    })}
                    value={
                      contactSelected?.email ? contactSelected?.email : null
                    }
                    onChange={handleInputContactEmail}
                  />
                  <Input
                    placeholder={intl.formatMessage({
                      id: 'global.input_contact_mobile',
                    })}
                    value={
                      contactSelected?.mobile ? contactSelected?.mobile : null
                    }
                    onChange={handleInputContactMobile}
                  />
                  <Button
                    type="primary"
                    onClick={() =>
                      setIsSelectOtherContact(!isSelectOtherContact)
                    }
                  >
                    <IntlMessages id="order.select_other_contact" />
                  </Button>
                </Space.Compact>
                {isSelectOtherContact && (
                  <Select
                    showSearch
                    options={contacts}
                    onSearch={handleSearchContact}
                    onChange={handleSelectContact}
                    placeholder={intl.formatMessage({
                      id: 'global.select_contact',
                    })}
                    filterOption={(input, option) =>
                      (option?.label ?? '')
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                  />
                )}
              </Space>
            </Form.Item>
            <Form.Item
              label={<IntlMessages id="order.pax" />}
              name={'pax'}
              rules={[
                {
                  required: true,
                  message: <IntlMessages id="global.requiredfield" />,
                },
              ]}
            >
              <InputNumber
                placeholder={intl.formatMessage({
                  id: 'global.input_pax',
                })}
                min={1}
                value={pax}
                onChange={handleChangePax}
                readOnly={
                  currentData?.order_status === OrderStatus.confirmed.status
                }
                style={{ minWidth: '30%' }}
              />
            </Form.Item>
            <Form.Item
              label={<IntlMessages id="global.guide_number" />}
              name={'guide_number'}
              rules={[
                {
                  required: false,
                },
              ]}
            >
              <InputNumber
                placeholder={intl.formatMessage({
                  id: 'global.input_guide_number',
                })}
                min={0}
                value={guideNumber}
                onChange={handleChangeGuideNumber}
                style={{ minWidth: '30%' }}
              />
            </Form.Item>
            <Form.Item
              label={<IntlMessages id="global.group_code" />}
              name="group_code"
              rules={[
                {
                  required: false,
                },
              ]}
            >
              <Input
                placeholder={intl.formatMessage({
                  id: 'global.input_group_code',
                })}
                value={groupCode}
                onChange={handleInputGroupCode}
              />
            </Form.Item>
            <Form.Item
              label={<IntlMessages id="global.seller" />}
              name="user"
              rules={[
                {
                  required: true,
                  message: <IntlMessages id="global.requiredfield" />,
                },
              ]}
            >
              <Select
                showSearch
                options={userOptions}
                value={userSelected && userSelected}
                onSearch={handleSearchUser}
                onChange={handleSelectUser}
                placeholder={intl.formatMessage({
                  id: 'global.select_seller',
                })}
                // style={{ minWidth: '200px' }}
                filterOption={(input, option) =>
                  (option?.label ?? '')
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
              />
            </Form.Item>
            <Form.Item
              label={<IntlMessages id="global.notes" />}
              name="notes"
              rules={[
                {
                  required: false,
                },
              ]}
            >
              <TextArea
                placeholder={intl.formatMessage({
                  id: 'global.input_order_notes',
                })}
                value={orderNotes || ''}
                onChange={handleInputOrderNotes}
                rows={4}
              />
            </Form.Item>
            <Form.Item
              label={<IntlMessages id="global.internal_notes" />}
              name="internal_notes"
              rules={[
                {
                  required: false,
                },
              ]}
            >
              <TextArea
                placeholder={intl.formatMessage({
                  id: 'global.input_order_internal_notes',
                })}
                value={orderInternalNotes || ''}
                onChange={handleInputOrderInternalNotes}
                rows={4}
              />
            </Form.Item>
          </Form>
        </React.Fragment>
      ),
    },
  ];

  return (
    <Modal
      title={<IntlMessages id="global.edit" />}
      open={open}
      destroyOnClose={true}
      onCancel={handleCancel}
      onOk={handleSubmit}
      footer={[
        <Button key="back" type="default" onClick={handleCancel}>
          {<IntlMessages id="global.cancel" />}
        </Button>,
        <Button
          key="submit"
          type="primary"
          htmlType="submit"
          loading={loading}
          onClick={handleSubmit}
        >
          {<IntlMessages id="global.save" />}
        </Button>,
      ]}
      width={'60%'}
    >
      {/* <SearchOrderForm
        currentData={currentData}
        searchOrder={handleSearchOrder}
      />
      {showSearchResult && departureSearchData.length > 0 && (
        <Departure
          searchData={departureSearchData}
          customer={currentData?.customer}
        />
      )}
      {showSearchResult && returnSearchData.length > 0 && (
        <Return
          searchData={returnSearchData}
          customer={currentData?.customer}
        />
      )} */}

      {/* <Card title="Select customer" style={{ border: 'none' }}>
        <Input
          value={`${currentData?.customer?.fullname}${
            currentData?.customer?.company_shortname
              ? ` - ${currentData?.customer?.company_shortname}`
              : ''
          }${
            currentData?.customer?.mobile
              ? ` - ${currentData?.customer?.mobile}`
              : ''
          }${
            currentData?.customer?.cgroup
              ? ` (${currentData?.customer?.cgroup?.title})`
              : ''
          }`}
          style={{ maxWidth: '430px' }}
          readOnly
        />
        <Input
          placeholder="Input Code"
          style={{ maxWidth: '150px', marginLeft: '12px' }}
          value={groupCode}
          onChange={handleInputGroupCode}
          // disabled={!showSearchResult}
        />
        <Select
          showSearch
          options={userOptions}
          value={userSelected && userSelected}
          onSearch={handleSearchUser}
          onChange={handleSelectUser}
          placeholder="Select user"
          style={{ minWidth: '200px', marginLeft: '12px' }}
          // disabled={!showSearchResult}
          filterOption={(input, option) =>
            (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
          }
        />
      </Card> */}

      {/* <React.Fragment>
        <br />
        <Card
          // title={`Order Detail - Discount: ${
          //   currentData?.customer?.cgroup?.discount
          //     ? currentData?.customer?.cgroup?.discount
          //     : 0
          // }%`}
          title={
            currentData?.customer?.cgroup?.discount
              ? `Order Detail - Discount: ${currentData?.customer?.cgroup?.discount}%`
              : 'Order Detail'
          }
          style={{ border: 'none' }}
        >
          {(departureEditOrder?.cabins.length > 0 ||
            departureEditOrder?.addons.length > 0) && (
            <React.Fragment>
              <Title
                level={5}
                style={{
                  marginTop: '0',
                }}
              >
                Departure
              </Title>
              <Row>
                <Title
                  level={5}
                  style={{
                    margin: '0 12px 0 30px',
                    minWidth: '100px',
                  }}
                >
                  Cabins
                </Title>
                {departureEditOrder?.cabins.length > 0 && (
                  <Table
                    columns={detailColumns}
                    dataSource={departureEditOrder?.cabins}
                    tableLayout="auto"
                    rowKey={'cabin_id'}
                    scroll={{
                      x: 'max-content',
                    }}
                    size="small"
                    pagination={false}
                    style={{ flex: '1' }}
                  />
                )}
              </Row>
              <Row style={{ marginTop: '15px' }}>
                <Title
                  level={5}
                  style={{
                    margin: '0 12px 0 30px',
                    minWidth: '100px',
                  }}
                >
                  Add-ons
                </Title>
                {departureEditOrder?.addons.length > 0 && (
                  <Table
                    columns={detailColumns}
                    dataSource={departureEditOrder?.addons}
                    tableLayout="auto"
                    rowKey={'addon_id'}
                    scroll={{
                      x: 'max-content',
                    }}
                    size="small"
                    pagination={false}
                    style={{ flex: '1' }}
                  />
                )}
              </Row>
            </React.Fragment>
          )}
          {(returnEditOrder?.cabins.length > 0 ||
            returnEditOrder?.addons.length > 0) && (
            <React.Fragment>
              <Title
                level={5}
                style={{
                  marginTop: '0',
                }}
              >
                Return
              </Title>
              <Row>
                <Title
                  level={5}
                  style={{
                    margin: '0 12px 0 30px',
                    minWidth: '100px',
                  }}
                >
                  Cabins
                </Title>
                {returnEditOrder?.cabins.length > 0 && (
                  <Table
                    columns={detailColumns}
                    dataSource={returnEditOrder?.cabins}
                    tableLayout="auto"
                    rowKey={'cabin_id'}
                    scroll={{
                      x: 'max-content',
                    }}
                    size="small"
                    pagination={false}
                    style={{ flex: '1' }}
                  />
                )}
              </Row>
              <Row style={{ marginTop: '15px' }}>
                <Title
                  level={5}
                  style={{
                    margin: '0 12px 0 30px',
                    minWidth: '100px',
                  }}
                >
                  Add-ons
                </Title>
                {returnEditOrder?.addons.length > 0 && (
                  <Table
                    columns={detailColumns}
                    dataSource={returnEditOrder?.addons}
                    tableLayout="auto"
                    rowKey={'addon_id'}
                    scroll={{
                      x: 'max-content',
                    }}
                    size="small"
                    pagination={false}
                    style={{ flex: '1' }}
                  />
                )}
              </Row>
            </React.Fragment>
          )}
          {(departureEditOrder?.cabins.length > 0 ||
            departureEditOrder?.addons.length > 0 ||
            returnEditOrder?.cabins.length > 0 ||
            returnEditOrder?.addons.length > 0) && (
            <Row justify={'end'}>
              <Title level={5}>
                Total: <Currency value={totalMoney} />
              </Title>
            </Row>
          )}
        </Card>
      </React.Fragment> */}

      <Tabs defaultActiveKey="1" items={tabItems} />
    </Modal>
  );
};

export default EditOrderForm;
